(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ulti-arc-variations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setupCarousel = (section) => {
    if (section.dataset.carouselReady === 'true') return;
    const track = section.querySelector('[data-carousel-track]');
    const previous = section.querySelector('[data-carousel-previous]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track || !previous || !next) return;
    section.dataset.carouselReady = 'true';

    const updateControls = () => {
      const limit = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= limit - 2;
    };

    const move = (direction) => {
      const card = track.querySelector('.ulti-arc-variation');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
    new ResizeObserver(updateControls).observe(track);
    updateControls();
  };

  document.querySelectorAll('[data-arc-variations]').forEach(setupCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-arc-variations]');
    if (section) setupCarousel(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulti-premium-builder"] && !Shopify.designMode) return;
  try {
    
function initializePremiumProductLabels(root = document) {
  root.querySelectorAll('.ulti-premium-builder').forEach(container => {
    if (container.dataset.premiumLabelsInitialized || container.dataset.defaultVariant === 'true') return;
    const controls = container.querySelector('[data-product-options]');
    if (!controls) return;
    container.dataset.premiumLabelsInitialized = 'true';
    const normalizeName = value => {
      const name = value.replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();
      if (/^colou?r(?: family)?$/i.test(name)) return container.dataset.colourLabel || name;
      return name.charAt(0).toUpperCase() + name.slice(1);
    };
    const normalizeLabels = () => {
      const legends = controls.querySelectorAll('legend');
      if (!legends.length) return false;
      legends.forEach(legend => { legend.textContent = normalizeName(legend.textContent); });
      controls.querySelectorAll('[role="radiogroup"][aria-label]').forEach(group => {
        group.setAttribute('aria-label', normalizeName(group.getAttribute('aria-label')));
      });
      return true;
    };
    if (normalizeLabels()) return;
    const observer = new MutationObserver(() => {
      if (normalizeLabels()) observer.disconnect();
    });
    observer.observe(controls, { childList: true, subtree: true });
  });
}
initializePremiumProductLabels();
document.addEventListener('shopify:section:load', event => initializePremiumProductLabels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulti-replo-promo"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-promo-moving]').forEach(promo => {
  const control = promo.querySelector('.ulti-promo-control');
  if (!control || control.dataset.initialized) return;
  control.dataset.initialized = 'true';
  control.addEventListener('click', () => {
    const paused = control.getAttribute('aria-pressed') !== 'true';
    control.setAttribute('aria-pressed', String(paused));
    control.setAttribute('aria-label', paused ? control.dataset.resumeLabel : control.dataset.pauseLabel);
    promo.dataset.paused = String(paused);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulti-replo-trust"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-trust-moving]').forEach(trust => {
  const control = trust.querySelector('.ulti-trust-pause');
  if (!control || control.dataset.initialized) return;
  control.dataset.initialized = 'true';
  control.addEventListener('click', () => {
    const paused = control.getAttribute('aria-pressed') !== 'true';
    control.setAttribute('aria-pressed', String(paused));
    control.textContent = paused ? control.dataset.resumeLabel : control.dataset.pauseLabel;
    trust.dataset.paused = String(paused);
  });
});

  } catch(e) { console.error(e); }
})();
})();
